import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../medeuon(2)/css/case_article.css";
import "../sunpharma(1)/css/case_journal.css";
import HomeBtn from "../components/HomeBtn";

import HTMLFlipBook from "react-pageflip";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import pdfjsWorker from "pdfjs-dist/legacy/build/pdf.worker.entry"; // Must be legacy path

import Footer from "../components/footer";
import Com_Logo from "../components/company_icon";

// Set the worker
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const App = () => {
  const [pages, setPages] = useState([]);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const loadPdf = async () => {
      try {
        const loadingTask = pdfjsLib.getDocument("../img/journal.pdf"); // PDF in public folder

        const pdf = await loadingTask.promise;
        const numPages = pdf.numPages;
        const pageImages = [];

        for (let i = 1; i <= numPages; i++) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 2 });
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({ canvasContext: context, viewport }).promise;
          const dataUrl = canvas.toDataURL();
          pageImages.push(dataUrl);
        }

        setPages(pageImages);
      } catch (err) {
        // console.error("Failed to load PDF:", err);
        setError("Failed to load or parse PDF. Please check the file.");
      }
    };

    loadPdf();
  }, []);

  const handlePrev = () => navigate("../case_event");
  const handleNext = () => navigate("../mcq");

  return (
    <>
      <Com_Logo />
      <div className="card custom-card" id="main_card">
        <div className="card-header bg-primary text-center" style={{ color: "white" }}>
          E - Journal
        </div>

        <div className="card-body">
          <figure className="mb-0">
            <div className="app-container">
              {error ? (
                <div className="text-danger text-center">{error}</div>
              ) : pages.length > 0 ? (
                <div className="flipbook-wrapper">
                  <HTMLFlipBook
                    width={350}
                    height={500}
                    size="stretch"
                    minWidth={300}
                    maxWidth={600}
                    minHeight={400}
                    maxHeight={800}
                    showCover={true}
                    mobileScrollSupport={true}
                  >
                    {pages.map((src, idx) => (
                      <div key={idx} className="page">
                        <img src={src} alt={`Page ${idx + 1}`} />
                      </div>
                    ))}
                  </HTMLFlipBook>
                </div>
              ) : (
                <div className="text-center my-5">
                  <div className="spinner-border text-primary" role="status"></div>
                  <p className="mt-3">Loading Journal...</p>
                </div>
              )}
            </div>
          </figure>
        </div>

        <div className="card-footer d-flex justify-content-between px-4">
          <button className="btn btn-secondary w-45" onClick={handlePrev}>
            Prev
          </button>
          <HomeBtn/>
          <button className="btn btn-primaryy w-45" onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default App;
